/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

/**
 * @param {RootState} state
 */
export function selectComponentsWithCategories (state) {
    return state.component.all;
}

/**
 * @param {RootState} state
 */
export function selectCategoryList (state) {
    return state.component.category.list;
}

/**
 * @param {RootState} state
 */
export function selectModelLoading (state) {
    return state.model.loading;
}

/**
 * @param {RootState} state
 */
export function selectCurrentModelType (state) {
    return state.model.current?.type;
}

/**
 * @param {RootState} state
 */
export function selectHasCurrentModel (state) {
    return !!state.model.current;
}

/**
 * @param {RootState} state
 * @returns {any[]}
 */
export function selectCurrentFields (state) {
    return state.model.current?.fields || [];
}
